module.exports = __webpack_public_path__ + "10bcddd933c2e80bc1059d247ad667a5.png";